function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed, toRefs } from "vue";
var LOADER_TYPES = {
  rectangle: "rectangle",
  circle: "circle"
};
var LOADER_CSS_CLASSES = _defineProperty(_defineProperty({}, LOADER_TYPES.rectangle, "tw-rounded-xs"), LOADER_TYPES.circle, "tw-rounded-full");
var SHIMMER_COLOR = "255,255,255"; //#ffffff
export default /*#__PURE__*/_defineComponent({
  __name: 'ShimmerLoader',
  props: {
    type: {
      type: String,
      "default": LOADER_TYPES.rectangle,
      validator: function validator(value) {
        return Object.values(LOADER_TYPES).includes(value);
      }
    },
    bgClass: {
      type: String,
      "default": "tw-bg-gray-300"
    },
    cssClass: {
      type: String,
      "default": ""
    }
    /* shimmerColor: {
        type: String,
        default: SHIMMER_COLOR,
    },*/
  },
  setup: function setup(__props) {
    /**
     * "breathing" animation loader with Wikicasa symbol
     */
    var props = __props;
    var _toRefs = toRefs(props),
      type = _toRefs.type,
      bgClass = _toRefs.bgClass,
      cssClass = _toRefs.cssClass;
    var shimmerStyle = computed(function () {
      return {
        backgroundImage: "linear-gradient(90deg, rgba(".concat(SHIMMER_COLOR, ", 0) 0%, rgba(").concat(SHIMMER_COLOR, ", 0.2) 20%, rgba(").concat(SHIMMER_COLOR, ", 0.5) 60%, rgba(").concat(SHIMMER_COLOR, ", 0))")
      };
    });
    var loaderClass = computed(function () {
      return cssClass.value ? cssClass.value : LOADER_CSS_CLASSES[type.value];
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        "class": _normalizeClass([_unref(bgClass), loaderClass.value, 'tw-relative tw-overflow-hidden'])
      }, [_createElementVNode("div", {
        "class": "shimmer tw-absolute tw-top-0 tw-right-0 tw-bottom-0 tw-left-0",
        style: _normalizeStyle(shimmerStyle.value)
      }, null, 4 /* STYLE */), _renderSlot(_ctx.$slots, "default")], 2 /* CLASS */);
    };
  }
});